import actions from './actions'

const defaultState = {
  passes: [],
  loading: false
}

const passes = (state = defaultState, action) => {
  switch (action.type) {
    case actions.setPasses:
      var currentState = state
      currentState.loading = false
      var i = currentState.passes.findIndex(x => x.siteCode === action.payload.siteCode)
      if (i === -1) {
        currentState.passes.push({
          siteCode: action.payload.siteCode,
          passesList: action.payload.passes
        })
      }
      else {
        currentState.passes[i].passesList = action.payload.passes
      }
      return currentState

    case actions.fetchPending:
      return { ...state, loading: true }

    case actions.setVisitPassDetails:
      return { ...state, passDetails: action.passDetails, actionRequired: action.actionRequired }

    default:
      return state
  }
}

export default passes



// WEBPACK FOOTER //
// ./src/store/passes/reducer.js